import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap';

import ReactQuill from 'react-quill';
import Carousel from 'react-bootstrap/Carousel';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css'
import { useSelector } from 'react-redux';
import announcementBiz from '../biz/announcementBiz';
import TenancyRenewalModal from './TenancyRenewalModal';

const AnnouncementModal = (props) => {
    const { modal, setModal, announcements, mode } = props

    const [checked, setChecked] = useState([]);
    const [renewlModal, setRenewalModal] = useState(false)
    const [formData, setFormData] = useState({})
    const carouselInnerRef = useRef(null);

    const userSlice = useSelector((state) => state.user);
    const navigate = useNavigate()
    const showControls = announcements.length > 1

    const handleCancel = async (checkedList = checked) => {
        setModal(false)
        if (mode !== "preview" && checkedList.length !== 0) {
            const announcementIds = userSlice.unread.map(ann => ann._id)
            const unread = announcementIds.filter(option => !checkedList.includes(option))
            await announcementBiz.updateUserReadReceipt({ _id: userSlice._id, unread, read: checkedList })
        }
        setChecked([])
    }

    const handleRenew = (action, announcement) => {
        if (action === 'subscription') {
            navigate('/owner/my-subscription')
            handleCancel()
        } else {
            setRenewalModal(true)
            setFormData(announcement)
        }
    }

    const handleCheck = (e) => {
        if (e.target.checked) {
            setChecked([...checked, e.target.id])
        } else {
            setChecked(checked.filter((option) => option !== e.target.id));
        }
    }

    const handleSlide = () => {
        const innerEl = carouselInnerRef.current?.querySelector('.carousel-inner');
        if (innerEl) {
            innerEl.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
            <Modal
                id='kt_modal_create_app'
                tabIndex={-1}
                aria-hidden='true'
                dialogClassName='modal-dialog modal-dialog-centered mw-624px'
                show={modal}
                onHide={handleCancel}
                backdrop={true}
                size={"lg"}
            >
                <Modal.Header closeButton className='pb-0'>
                </Modal.Header>
                <Modal.Body ref={carouselInnerRef}>
                    <Carousel
                        interval={null}
                        variant='dark'
                        indicators={showControls}
                        controls={showControls}
                        slide={false}
                        onSlid={handleSlide}
                    >
                        {announcements.map((ann) => (
                            <Carousel.Item className={showControls && 'control-pd'}>
                                <h2 className='mb-0 mt-2'>{ann.title}</h2>
                                <ReactQuill
                                    value={ann.content}
                                    readOnly={true}
                                    theme="bubble"
                                    className='ql-container'
                                />
                                {ann?.type === 'Subscription Announcement' &&
                                    <div className="d-flex justify-content-center" style={{ marginBottom: '10px' }}>
                                        <button className='btn btn-primary ' onClick={() => handleRenew('subscription')}>Renew Subscription</button>
                                    </div>
                                }
                                {ann?.type === 'Tenancy Renewal Reminder' &&
                                    <div className="d-flex justify-content-center" style={{ marginBottom: '10px' }}>
                                        <button className='btn btn-primary ' onClick={() => handleRenew('tenancy', ann)}>Renew Now</button>
                                    </div>
                                }
                                <div className={`form-check d-flex gap-3 jc-center ${showControls && 'mb-15'}`}>
                                    <input
                                        id={ann._id}
                                        key={ann._id}
                                        className="form-check-input"
                                        name="checked"
                                        type="checkbox"
                                        checked={checked.includes(ann._id)}
                                        onChange={e => handleCheck(e)}
                                    />
                                    <label htmlFor={ann._id}>I acknowledge it. Don't show this again.</label>
                                </div>
                            </Carousel.Item>
                        ))
                        }
                    </Carousel>
                </Modal.Body>
            </Modal >
            <TenancyRenewalModal
                modal={renewlModal}
                setModal={setRenewalModal}
                formData={formData}
                setFormData={setFormData}
                handleCancel={handleCancel}
                mode={'renew'}
            />
        </>
    )
}

export default AnnouncementModal
